/** Клик по ячейке в режиме редактирования EdiTable — не toggles row checkbox. */
export function isEditableTableCellClick(target: HTMLElement | null | undefined): boolean {
  if (!target) return false

  if (
    target.closest(
      '.table-cell-editor, .table-cell-editor-checkbox, .table-cell-editor-listbox',
    )
  ) {
    return true
  }

  const cell = target.closest('td')
  if (!cell) return false

  if (cell.classList.contains('table-column-editable')) return true
  if (cell.classList.contains('p-cell-editing')) return true

  return false
}
